module.exports = __webpack_public_path__ + "img/nitja-ung-500px.1b80dd95.svg";